import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export interface DashboardWidgetProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  onMenuClick?: () => void;
}

export const DashboardWidget: React.FC<DashboardWidgetProps> = ({
  title,
  children,
}) => {

  return (
    <Paper
      sx={{
        height: "100%",
        minWidth: 350,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          px: "16px !important",
          
        }}
      >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600, 
              fontSize: "18px",
            }}
          >
            {title}
          </Typography>
      </Box>
      <Box 
        sx={{ 
          flex: 1, 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

